export enum FiOnboardingCompletionStateType {
    NotCompleted = 0,
    InProgress = 1,
    Completed = 2,
}

export enum FiOnboardingQuizCompletionStateType {
    NotCompleted = 0,
    InProgress = 1,
    Completed = 2,
    Failed = 3,
}

export enum FiOnboardingStepReopenedReason {
    Unknown = 0,
    QuestionOrTodoItemAdded = 1,
    StepElementSettingsChanged = 2,
}

/*
export enum FiOnboardingCompletionViewStateType {
    Active = 0,
    Disabled = 1,
    InProgress = 2,
    Completed = 3,
}
*/
